export default {
    buttons: {
        save: 'Sačuvaj',
        resend: 'Resend SMS',
    },
    fields: {
        phone: {
            label: 'Broj telefona',
            placeholder: '+3811231231',
        },
    },
    errors: {
        user_resend_limit_reached_contact_support: 'Dostignuto je ograničenje za ponovno slanje, kontaktirajte podršku!',
        user_resend_limit_reached: 'Dostignuto je ograničenje za ponovno slanje, molimo pokušajte ponovo za 15 minuta',
        user_mobile_already_verified: 'Ovaj broj telefona je već verifikovan',
        user_resend_spam_detected: 'Dostignuto je ograničenje za ponovno slanje, kontaktirajte podršku!',
    },
}
